import { render, staticRenderFns } from "./WhatsappProviderTariffs.vue?vue&type=template&id=3d54be93&"
import script from "./WhatsappProviderTariffs.vue?vue&type=script&lang=ts&"
export * from "./WhatsappProviderTariffs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports